import * as actions from "./negara.actions";
import { ActionType, createReducer } from "typesafe-actions";
import { NegaraReducerType } from "./types";

export type NegaraActions = ActionType<typeof actions>;

export const initialState: NegaraReducerType = {
  isLoading: false,
  errorMessage: '',
  listNegara: [],
};

export const NegaraReducer = createReducer<
NegaraReducerType,
  NegaraActions
>(initialState)
  .handleAction(actions.getNegaraAsync.request, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getNegaraAsync.success, (state, action) => ({
    ...state,
    errorMessage: '',
    isLoading: false,
    listNegara: action.payload.data.items,
  }))
  .handleAction(actions.getNegaraAsync.failure, (state, action) => ({
    ...state,
    errorMessage: action.payload.message,
    isLoading: false,
  }))
